(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardMapController", DeviceMessageBoardMapController)

    DeviceMessageBoardMapController.$inject = [
        "$state",
        "$scope",
        "$stateParams",
        "$filter",
        "prefs",
        "messageBoardsService",
        "historyService",
        "googleMapsService",
        "userMessagingService"
    ]

    function DeviceMessageBoardMapController(
        $state,
        $scope,
        $stateParams,
        $filter,
        prefs,
        messageBoardsService,
        historyService,
        googleMapsService,
        userMessagingService
    ){
        "use strict"

        /**
            $scope variables
         **/

        $scope.showBreadCrumbs = prefs.get().messageBoard.showBreadcrumbs

        $scope.editLocation         = false
        $scope.gpsHistory           = []
        $scope.gpsHistoryFiltered   = []
        $scope.gpsHistoryMaxRecords = 350

        $scope.units = [
            {unit: "mi", label: "mi"},
            {unit: "km", label: "km"}
        ]

        let map = undefined

        const updateBreadCrumbs = () => {
            let connectCurrent = true
            let gpsHistory = $scope.showBreadCrumbs === true ? $scope.gpsHistory : []
            if (gpsHistory.length > 0 && $scope.bcFilter.isApplied) {
                gpsHistory = $scope.gpsHistoryFiltered
                gpsHistory.splice(0, 0, $scope.gpsHistory[0])
                connectCurrent = false
            }
            if (map === undefined) {
                googleMapsService.createMap("mapConstruct").then((mapObject) => {
                    map = mapObject
                    googleMapsService.setSingleMarker(true, map, $scope.messageBoard, gpsHistory, connectCurrent)
                    googleMapsService.setGeofence(map, $scope.messageBoard)
                })
            } else {
                googleMapsService.setSingleMarker(false, map, $scope.messageBoard, gpsHistory, connectCurrent)
                googleMapsService.setGeofence(map, $scope.messageBoard)
            }
        }

        const updateDisplay = () => {

            updateBreadCrumbs()

            $scope.locationFormData = {
                lat: $filter("number")($scope.messageBoard.gps.lat || 0, 4),
                lon: $filter("number")($scope.messageBoard.gps.lon || 0, 4),
                geofence_center_lat: $filter("number")($scope.messageBoard.gps.geofence_center_lat || 0, 4),
                geofence_center_lon: $filter("number")($scope.messageBoard.gps.geofence_center_lon || 0, 4),
                geofence_radius:  $filter("number")($scope.messageBoard.gps.geofence_radius || 0.5, 2),
                geofence_units: $scope.messageBoard.gps.geofence_units || "mi"
            }
        }

        $scope.toggleBreadCrumbs = () => {

            $scope.showBreadCrumbs = !$scope.showBreadCrumbs
            updateBreadCrumbs()
            prefs.set(prefs.selectors().messageBoard.showBreadcrumbs, $scope.showBreadCrumbs)

        }

        $scope.toggleEdit = () => {
            gtag("event", "create_geofence", { action: $scope.editLocation ? "cancel" : "begin", device_id: $scope.messageBoard.device.id })
            $scope.editLocation = !$scope.editLocation
        }

        /**
            Center geofence
         **/
        $scope.centerGeofence = () => {
            $scope.locationFormData.geofence_center_lat = $filter("number")($scope.messageBoard.gps.lat || 0, 4)
            $scope.locationFormData.geofence_center_lon = $filter("number")($scope.messageBoard.gps.lon || 0, 4)
        }

        /**
            Edit message board location
         **/
        $scope.editMessageBoardLocation = () => {

            $scope.submitted = true

            if ($scope.editLocationForm.$valid) {

                const success = () => {
                    gtag("event", "create_geofence", { action: "complete", device_id: $scope.messageBoard.device.id })

                    $scope.messageBoard.gps.geofence_center_lat = $scope.locationFormData.geofence_center_lat
                    $scope.messageBoard.gps.geofence_center_lon = $scope.locationFormData.geofence_center_lon
                    $scope.messageBoard.gps.geofence_radius = $scope.locationFormData.geofence_radius
                    $scope.messageBoard.gps.geofence_units = $scope.locationFormData.geofence_units

                    $state.go($state.$current, null, { reload: true }).then(() => {
                        userMessagingService.success("Location Edit Successful")
                    })
                }

                const failure = (error) => {
                    userMessagingService.error(error)
                }

                const ignoreDuplicateIPs = true

                messageBoardsService.editMessageBoard($stateParams.message_board_id, angular.fromJson($scope.locationFormData), ignoreDuplicateIPs, success, failure)
                $scope.editLocation = false
            }
        }

        /**
            Datepicker config
         **/

        $scope.bcFilter = {
            fromDate: {
                value:  undefined,
                isOpen: false,
                format: "yyyy-MM-dd",
                options: {
                    formatYear:  "yy",
                    startingDay: 1,
                    showWeeks:   false,
                    maxDate:     new Date()
                }
            },
            toDate: {
                value: undefined
            },
            duration:   "7",
            allowApply: true,
            isApplied:  false
        }

        $scope.openBcFromDate = () => {
            $scope.bcFilter.fromDate.isOpen = true
        }

        $scope.bcClearFilter = () => {

            $scope.bcFilter.fromDate.value = undefined
            $scope.bcFilter.isApplied = false
            updateBreadCrumbs()

        }

        $scope.bcChangeFilter = () => {

            $scope.bcCalculateToDate()

            if ($scope.bcFilter.isApplied && $scope.bcFilter.fromDate.value === undefined) {

                $scope.bcClearFilter()

            }

            $scope.bcFilter.isApplied = false

        }

        $scope.bcCalculateToDate = () => {

            $scope.bcFilter.toDate.value = undefined

            if ($scope.bcFilter.fromDate.value !== undefined && $scope.bcFilter.fromDate.value !== null) {

                let days = Number($scope.bcFilter.duration)
                let seconds = $scope.bcFilter.fromDate.value.getTime() + (days * 24 * 60 * 60 * 1000)
                $scope.bcFilter.toDate.value = new Date(seconds)


            } else {

                $scope.bcFilter.fromDate.value = undefined

            }
        }

        $scope.bcApplyFilter = () => {

            $scope.bcCalculateToDate()

            if ($scope.bcFilter.fromDate.value === undefined) {

                $scope.bcClearFilter()

            } else if ($scope.bcFilter.allowApply) {

                $scope.bcFilter.isApplied = true

                $scope.bcFilter.allowApply = false

                historyService.getGPSHistory("MessageBoard", $stateParams.message_board_id, $scope.bcFilter.fromDate.value, $scope.bcFilter.toDate.value, 1, $scope.gpsHistoryMaxRecords).then((data) => {

                    $scope.gpsHistoryFiltered = data
                    updateBreadCrumbs()
                    $scope.bcFilter.allowApply = true

                })
            }
        }

        /**
            Watch for telemetry update
         **/

        $scope.$watch("$root.pushedData", (pushedData) => {

            if (pushedData.device.hasOwnProperty("device") && $scope.messageBoard.hasOwnProperty("device")) {

                if (pushedData.device.device.id === $scope.messageBoard.device.id) {

                    if (pushedData.device.hasOwnProperty("telemetry")) {
                        $scope.gpsHistory.unshift($scope.messageBoard.telemetry)
                    }

                    updateDisplay()

                }
            }
        })

        $scope.$watch("retrievedMessageBoard", (retrievedMessageBoard) => {

            if (retrievedMessageBoard) {

                historyService.getGPSHistory("MessageBoard", $stateParams.message_board_id, "", "", 1, $scope.gpsHistoryMaxRecords).then((data) => {

                    $scope.gpsHistory = data
                    updateDisplay()

                })
            }
        })
    }
})()
